module.exports = __webpack_public_path__ + "assets/img/9170db79729dc9413f46a621f01c9e85.svg";